export default {
    name: 'Appendix A - Educational Attainment Documentation',
    pageInfo: {
        text:
            `
        You must complete and attach Appendix A with documentation for any H-1B nonimmigrant worker where the statuatory exemption for that worker will be based only on the Master's or higher degree exemption.  If the employer will claim the exemption for more than five (5) workers with different educational attainment information, the employer must report as many additional sections of educational attainment information as are necessary to cover all "exempt" H-1B nonimmigrant workers employed under the LCA.
        `,
        coloring: 'grey',
    },
    pageAlert: {
        widget: 'pageAlert',
        alerts: [
            {
                title: 'Information Required',
                description:
                    'Please complete sections A and H to determine if an Appendix A is required for this application.',
                type: 'info',
                isVisible: {
                    when: 'a1_visa_type h1_is_dependent h2_is_willful_violator',//don't know exact conditions yet
                    is: 'undefined undefined undefined',
                    operator: 'compareMultiFieldValuesOR_ISArray',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type h1_is_dependent h2_is_willful_violator',
                    is: ['H-1B', 'NO', 'NO'],
                    operator: 'compareMultiFieldValues',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type h1_is_dependent h2_is_willful_violator h3_only_h1b h4_exemption_basis',
                    is: ['H-1B', 'YES', 'YES', 'YES', 'Both'],
                    operator: 'compareMultiFieldValues',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type h1_is_dependent h2_is_willful_violator h3_only_h1b h4_exemption_basis',
                    is: ['H-1B', 'YES', 'YES', 'YES', '$60,000 or higher annual wage'],
                    operator: 'compareMultiFieldValues',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type',
                    is: 'H-1B1 Chile',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type',
                    is: 'H-1B1 Singapore',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'a1_visa_type',
                    is: 'E-3 Australian',
                }
            },
            {
                title: 'Section Complete',
                description:
                    "Because you indicated this application is not related to H-1B Dependent or Willful Violator Employers - Master's Degree or Higher Exeptions ONLY (per sections A and H), no Appendix A is necessary for this application.",
                type: 'success',
                isVisible: {
                    when: 'h3_only_h1b',
                    is: 'NO',
                }
            },
        ]
    },
    sections: [
        {
            divider: 'hide',
            fields : [
                {
                    isVisible: {
                        when: 'h4_exemption_basis',
                        is: ['Master\'s Degree or higher in related speciality'],
                        operator: 'compareMultiFieldValues',
                    },
                    code: 'Appendix A',
                    machine_name: 'appendix_a_total_workers',
                    widget: 'text',
                    inputType: 'hidden', // hidden field to display field/page level error
                    validate: [
                        {
                            valueChecker: 'number_exempt_workers',
                            needsFieldValues: true,
                            message: 
                            `
                            Total workers entered into Appendix A must be greater than or equal to the number of workers entered in B.7                            
                            `,
                            extraData: {
                              check: 'fieldArraySum',
                              fieldArray: {
                                  machine_name: 'appendix_a',
                                  singleRowCheck: true,
                                  operator: '!=',
                                  message: 
                                  `
                                  Total workers entered in Appendix A must equal the number of workers in B.7              
                                  `
                              },
                              field: 'number_exempt_workers',
                              operator: '<',
                              valueOf: 'b7_total_positions',
                              valueOfFieldName: 'B.7: Total Worker Positions Being Requested for Certification',
                            //   prefix: 'add_values_field',
                            //   modal: true,
                              
                            }
                        },
                    ],
                    
                }
            ]
        },
        {
            isVisible: {
                    when: 'h4_exemption_basis',
                    is: ['Master\'s Degree or higher in related speciality'],
                    operator: 'compareMultiFieldValues'
            },
            code: 'Appendix A',
            machine_name: 'appendix_a',
            isModal: true,
            sectionHeader: 'Record(s)',
            openModalHeader: 'Add an Appendix A',
            modalHeader: 'Add Educational Attainment Information',
            listType: 'table',
            removeFromFieldArray: true,
            validate: ['tableRequired', 'tableIncomplete'],
            modalFields: [
                {
                    machine_name: "number_exempt_workers",
                    label: `Workers`,
                    widget: "number",
                    validate: [
                        {
                            minValue: 1,
                            message: 'Please enter at least one Worker'
                        },
                        'required',
                        'number',
                    ],
                    parse:'positiveWholeNumber',
                    maxLength: 4,
                    tooltip:"Enter the number of H-1B nonimmigrant workers that the H-1B dependent or willful violator employer will seek exemption status based on attainment of a master’s or higher degree (or its equivalent) in a specialty related to the intended employment who attended the same institution with the same field of study and date of degree. The total number of H-1B nonimmigrant workers entered in this field must not be greater than the entry for “Total Worker Positions Being Requested for Certification” provided in Item B.7, Form ETA- 9035. Where multiple sections of educational attainment information are entered, the sum of the number of H-1B nonimmigrant workers entered in this field in each section must not be greater than the entry for “Total Worker Positions Being Requested for Certification” provided in Item B.7, Form ETA- 9035."
                },
                {
                    machine_name: "institution_name",
                    label: `Institution`,
                    widget: "text",
                    validate: ['required'],
                    maxLength: 60,
                    tooltip:"Enter the full name of the accredited or recognized institution (e.g., college or university) that awarded the degree to the H-1B nonimmigrant worker(s)."
                },
                {
                    machine_name: "field_of_study",
                    label: `Field of Study`,
                    widget: "text",
                    validate: ['required',],
                    maxLength: 35,
                    tooltip:"Enter the field of study in which the degree was awarded to the H-1B nonimmigrant worker(s)."
                },
                {
                    hideOnTable: true,
                    machine_name: "degree_date",
                    label: `Date degree was awarded`,
                    widget: "date",
                    validate: ['required',
                    {
                        dateStartCheck: 'degree_date',
                        message: `Future dates are invalid.`,
                        isModal: true,
                        needsFieldValues: true,
                        extraData: {
                          greaterThanValue: 0,
                        }
                    }],
                    tooltip:"Enter the date on which the degree was awarded to the H-1B nonimmigrant worker(s)."
                },
                {
                    hideOnTable: true,
                    name:'Degree/Diploma',
                    machine_name: 'degree_diploma',
                    widget: 'file_upload',
                    label: 'Degree/Diploma',
                    fileTypes: ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx'],
                    validate: [
                        {
                            subsetOfSetRequired: "add_values_field",
                            message: "This field is required",
                            needsFieldValues: true,
                            extraData: {
                                numRequired: 1,
                                fieldArray: [
                                    "degree_diploma",
                                    "transcript",
                                    "other_official_documents"

                                ]
                            }
                        }
                    ],

                },
                {
                    hideOnTable: true,
                    name:'Transcript',
                    machine_name: 'transcript',
                    widget: 'file_upload',
                    label: 'Transcript',
                    fileTypes: ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx'],
                    validate: [
                        {
                            subsetOfSetRequired: "add_values_field",
                            message: "This field is required",
                            needsFieldValues: true,
                            extraData: {
                                numRequired: 1,
                                fieldArray: [
                                    "degree_diploma",
                                    "transcript",
                                    "other_official_documents"

                                ]
                            }
                        }
                    ],
                },
                {
                    hideOnTable: true,
                    name:'Other Official Documentation',
                    machine_name: 'other_official_documents',
                    widget: 'file_upload',
                    label: 'Other Official Documentation',
                    fileTypes: ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx'],
                    validate: [
                        {
                            subsetOfSetRequired: "add_values_field",
                            message: "This field is required",
                            needsFieldValues: true,
                            extraData: {
                                numRequired: 1,
                                fieldArray: [
                                    "degree_diploma",
                                    "transcript",
                                    "other_official_documents"

                                ]
                            }
                        }
                    ],
                },
            ],

        },
        {
            code: 'Appendix',
            machine_name: 'files',
            widget: 'text',
            hidden: true,
        },
    ]
}



